import React from 'react';
import RetIslrForm from '../../components/Forms/RetIslrForm.jsx';
import DataCard from '../../components/DataCard.jsx';
import DataListAndSearch from '../../components/DataListAndSearch.jsx';
import Paper from 'material-ui/Paper';
import RetIslrStore from '../../reflux/stores/RetIslrStore';
import RetIslrActions from '../../reflux/RetIslrActions';
import ProveedoresActions from '../../reflux/ProveedoresActions';
import ProveedorStore from '../../reflux/stores/ProveedorStore';
import AuthStore from '../../reflux/stores/AuthStore';
import AlertActions from '../../reflux/AlertActions';
import RetIslr from '../../Models/RetIslr';
import Check from 'material-ui/svg-icons/action/check-circle';
import _ from 'underscore';

export default class RetIslrCreate extends React.Component {
    constructor(props) {
        super(props);
        let label = function() { return this.codigo + ' - '+this.porcentaje+ '% - ' + this.descripcion;};
        this.state = {
            retIslr: new RetIslr({}),
            proveedores: [],
            proxima: 0,
            sendMail: false,
            tipos_retencion: []
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleRetIslr = this.handleRetIslr.bind(this);
        this.handleProveedores = this.handleProveedores.bind(this);
        this.handleSelectProveedor = this.handleSelectProveedor.bind(this);
        this.toggleMail = this.toggleMail.bind(this);
    }

    componentWillMount() {
        if (!AuthStore.getCliente().active_suscripcion)
            this.props.router.push('/expired');

        if (this.props.params.id) {
            RetIslrActions.getRetIslr(this.props.params.id);
        } else {
            ProveedoresActions.getProveedores();
        }
    }

    componentDidMount() {
        this.unsubscribe = RetIslrStore.listen(this.handleRetIslr);
        this.unsubscribeP = ProveedorStore.listen(this.handleProveedores);
    }

    componentWillUnmount() {
        this.unsubscribe();
        this.unsubscribeP();
    }

    handleRetIslr(e, retIslr, sentByMail) {
        let sent = null;

        if (sentByMail === "true")
            sent = (
                <p><img src="/public/images/mail-sent.gif" alt=""/>Su comprobante ha sido enviado por correo electronico</p>
            );

        if (e === 'getRetIslr') {
            ProveedoresActions.getProveedor(retIslr.proveedor.id, true);
            this.setState({retIslr: retIslr});
        }

        if (e === 'postedRetIslr') {
            const title = <div>Comprobante Creado <Check color="green" /></div>;
            const msg = (
                <div>
                    <p>Ha creado satisfactoriamente un comprobante de retención de I.S.L.R. con el N° {retIslr.numero} perteneciente a {retIslr.proveedor.name}</p>
                    {sent}
                </div>
            );
            AlertActions.alert('open', title, msg);
            this.props.router.push('/retislr');
        }


        if (e === 'putRetIslr') {
            const msg = <div>Comprobante Editado <Check color="green" /></div>;
            AlertActions.alert('open', msg, 'Ha editado satisfactoriamente un comprobante de retención de I.S.L.R. con el N° '+retIslr.numero+' perteneciente a '+retIslr.proveedor.name);
            this.props.router.push('/retislr');
        }
    }

        /**
     * Handles changes in the ProveedorStore
     *
     * @param {string} e The event being fired
     * @param {Array} or {Object} proveedores Can be either an array of Proveedor
     * or a single Proveedor.
     * @param {number} proxima The next retencion
     */
    handleProveedores(e, proveedores, count,  proxima, proxima_renta, tipos) {
        if (e === 'getProveedores') {
            let retIslr = this.state.retIslr;
            retIslr.proveedor = null;
            this.setState({proveedores: proveedores, retIslr: retIslr, count: count, proxima: proxima_renta});
        }

        if (e === 'getProveedor') {
            let retIslr = this.state.retIslr;
            retIslr.numero = proxima_renta;
            retIslr.proveedor = proveedores;

            this.setState({
                retIslr: retIslr,
                tipos_retencion: tipos
            });
        }

        if (e === 'putProveedor') {
            let retIslr = this.state.retIslr;
            retIslr.proveedor = proveedores;
            this.setState({
                retIslr: retIslr,
                proveedorEdit: false
            });
        }

        if (e === 'filter') {
            this.setState({
                proveedores: proveedores,
            });
        }

    }

    /**
     * Select a Proveedor to make a RetIva
     *
     * @param {number} id The index of the proveedor in this.state.proveedores
     *
     */
    handleSelectProveedor(id) {
        ProveedoresActions.getProveedor(this.state.proveedores[id].id, true);
    }

    onChange(e, value) {
        let retIslr = this.state.retIslr;

        switch(e.target.name) {
            case 'numero':
                retIslr.numero = value;
                break;
            case 'fecha_retencion':
                retIslr.fecha_retencion = value;
                break;
            case 'tipo_documento':
                retIslr.tipo_documento = value;
                break;
            case 'numero_documento':
                retIslr.numero_documento = value;
                break;
            case 'numero_control':
                retIslr.numero_control = value;
                break;
            case 'fecha_documento':
                retIslr.fecha_documento = value;
                break;
            case 'base_retencion':
                retIslr.base_retencion = value.replace(',','.');
                break;
            case 'porcentaje_retencion':
                retIslr.codigo_retencion = '000';
                retIslr.porcentaje_retencion = value.replace(',', '.');
                break;
            case 'codigo_retencion':
                let tipo = this.state.tipos_retencion[value];

                retIslr.porcentaje_retencion = tipo.porcentaje;
                retIslr.codigo_retencion = tipo.codigo;

                retIslr.descripcion = tipo.codigo === '000' ? '' : 'Retención de ' + tipo.porcentaje + '% por concepto de ' + tipo.descripcion;
                break;
            case 'descripcion':
                retIslr.descripcion = value;
                break;
        }

        this.setState({retIslr: retIslr});
    }

    onSubmit(e) {
        if (!this.props.params.id)
            RetIslrActions.postRetIslr(this.state.retIslr, this.state.sendMail);
        if (this.props.params.id)
            RetIslrActions.putRetIslr(this.state.retIslr, this.state.sendMail);
    }

    /**
     * Handles search according to query received from TextField
     *
     * @param {event} e TextField in which the query is being typed
     *
     */
    handleSearch(q) {
        AlertActions.startLoading();
        ProveedoresActions.apiFilter(q);
    }

    toggleMail(e, val) {
        this.setState({sendMail: val});
    }

    render() {

        let list = null, form = null, view = null;

        if (this.state.retIslr.proveedor === null || this.state.retIslr.proveedor === undefined) {
            view = (
                <div className="retivacontainer" style={{marginTop:35}}>

                    <DataListAndSearch
                        searchTitle="Seleccione un proveedor"
                        onChangeInput={this.handleSearch}
                        handleEdit={() => ''}
                        handleSelect={this.handleSelectProveedor}
                        inputPlaceHolder="Buscar proveedor..."
                        criterios="nombre o rif del proveedor."
                        items={this.state.proveedores}
                        count={this.state.count}
                        rightButtonUseThis={true}
                        resourceName="proveedor"
                        showAddButton={false}
                        retencion={true}
                    />
                </div>
            );

        //OTHERWISE SHOW PROVEEDOR DATA AND RETIVA FORM
        } else {
            list = (
                <div className="row" style={{marginLeft:0}}>
                    <div className="col-xs-12" style={{paddingLeft:0}}><strong>Email:</strong> {this.state.retIslr.proveedor.email} </div>
                    <div className="col-xs-12" style={{paddingLeft:0}}><strong>Teléfono:</strong> {this.state.retIslr.proveedor.phone} </div>
                </div>
            );

            form = (
                <div style={{marginTop:35, maxWidth:700, marginLeft: 'auto', marginRight:'auto'}}>
                    <h2 className="center">Nueva Retención de I.S.L.R.</h2>
                    <DataCard
                        cardTitle={this.state.retIslr.proveedor.primaryText}
                        cardSubtitle={this.state.retIslr.proveedor.secondaryText}
                        inner={list}
                        actions={null} />

                    <RetIslrForm
                        sendMail={this.state.sendMail}
                        toggleMail={this.toggleMail}
                        onChange={this.onChange}
                        retislr={this.state.retIslr}
                        tipos_retencion={this.state.tipos_retencion}
                        onSubmit={this.onSubmit} />
                </div>
            );

            view = (<div>{form}</div>);

        }



        return (
            view
        );

    }
}



/** WEBPACK FOOTER **
 ** ./app-react/pages/RetIslr/RetIslrCreate.jsx
 **/